import { BaseAjaxForm } from "mixs/base/form_ajax_mixin";
import { validations }  from "apps/actions/validations";
import { save, get }    from "apps/actions/common";
import { api } from "apps/api";
import serializeJSON    from 'utilities/serialize_json';
import { deepmerge } from 'utilities/merge';
export class FormUnder extends BaseAjaxForm {
  validFunction = null;
  submitFunction = save;
}

riot.mixin('forms.dialogs.approved-nextstep', FormUnder as riot.TagMixin)
